import cx from 'classnames';

export default function SupportSection({
  active,
  complete,
  onActivate,
  noEdit,
  children,
}) {
  if (!active && !complete) {
    return <div />;
  }

  const controls = (
    <div className="support-section-controls">
      <a className="support-section-edit-button" onClick={onActivate}>
        edit
      </a>
    </div>
  );

  return (
    <div
      className={cx('support-section', { 'support-section-active': active })}
    >
      <div className="support-section-content">{children}</div>
      {!active && complete && !noEdit && controls}
    </div>
  );
}
